export default __webpack_public_path__ + "static/media/phase3.8f2178ab.png";